export const getApiErrorMessage = (error: any) => {
  return error.message + " (API: " + error.response.data.apierror.debugMessage + ")";
}
